var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    { class: `card ${_vm.theme} margin-bottom-0` },
    [
      _c(
        "div",
        { staticClass: "header" },
        [
          _c("font-awesome-icon", {
            staticClass: "padding-2xs",
            attrs: {
              icon: _vm.$v6.solid[_vm.avatar],
              "fixed-width": "",
              size: "3x",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "section text-left" }, [
        _c(
          "h4",
          [
            _c("span", { staticClass: "sr-only" }, [_vm._v("Commission")]),
            _vm._v(" "),
            _vm.type === "icon"
              ? [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.iconCount) +
                      "\n        Icon\n        "
                  ),
                  _vm.iconCount > 1 ? [_vm._v("s")] : _vm._e(),
                ]
              : [_vm._v("Your Logo")],
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "float-right",
                style: `color: var(--fa-dk-${_vm.theme});`,
              },
              [
                _c("span", { staticClass: "sr-only" }, [_vm._v("Cost:")]),
                _vm._v(
                  "\n        $" +
                    _vm._s(_vm.formatNumber(_vm.cost)) +
                    "\n      "
                ),
              ]
            ),
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "size-sm line-length-xs" }, [
          _c("p", [_vm._v(_vm._s(_vm.description))]),
          _vm._v(" "),
          _vm.type === "icon"
            ? _c("p", [
                _vm._v(
                  "Designed in " +
                    _vm._s(_vm.styleCount) +
                    " styles in both Font Awesome Classic and Font Awesome Sharp."
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.iconCount > 1
            ? _c("p", [
                _vm._v(
                  "$" +
                    _vm._s(_vm.formatNumber(_vm.costPerIcon)) +
                    " per individual icon."
                ),
              ])
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }